<template>
  <b-container fluid>
    <b-row id="tableId">
      <b-col xs="12" md="12" lg="12" xl="12" class="px-0">
        <h5 class="mb-0">{{ $t("Товар хисоботи")}}
          <v-select style="float: right;width: 40%;" class="form-control-sm md-input filt sssp" :options="settinglist"
            v-model="filtertype" :clearable="false" multiple :reduce="name => name.id" label="name">

          </v-select>
        </h5>
      </b-col>
      <span class="headexcel" style="display: contents;">
        <span style="display:contents;">
          <div class="my-1 column2-5">
            <label for="">{{ $t("Вақт") }} 1</label>
            <input class="form-control" type="date" v-model="datas.date1" />
          </div>
          <div class="my-1 column2-5">
            <label for="">{{ $t("Вақт") }} 2</label>
            <input class="form-control" type="date" v-model="datas.date2" />
          </div>
          <div class="my-1 column2-5">
            <label>Склад</label>
            <v-select class="form-control-sm md-input" :options="skladlist" @input="Send()" :disabled="skladhave"
              v-model="datas.sklad_id" :reduce="name => name.id" label="name" :clearable="false">
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </div>
          <div class="my-1 column2-5">
            <label>Группа</label>
            <v-select class="form-control-sm md-input" :options="folderlist" :clearable="true"
              v-model="datas.product_id" :reduce="extra_name => extra_name.id" label="extra_name">
            </v-select>
          </div>
          <div class="my-1 column2-5">
            <label for="">{{ $t("Нарх") }}</label>
            <v-select :clearable="false" class="form-control-sm" :options="senalist" @input="Jami()"
              v-model="datas.price" :reduce="name => name.id" label="name">
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </div>
          <div class="my-1 column2">
            <label for="">Валюта</label>
            <v-select :clearable="false" class="form-control-sm" :options="pricelist" v-model="valuta"
              :reduce="name => name.id" label="name">
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em><b>{{ search }}</b></em>
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
          </div>
          <div class="my-1 column1">
            <label>{{$t('Пачка')}}</label>
            <input type="checkbox" v-model="pack">
          </div>
          <div class="my-1 column1">
            <label>{{$t('Движения')}}</label>
            <input type="checkbox" v-model="movement">
          </div>
        </span>
      </span>
      <div class="my-1" style="width: 15%;">
        <br>
        <button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <button type="button" class="btn mybtn" @click="Print2()">
          <b-icon icon="printer"></b-icon>
        </button>
        <button type="button" class="btn mybtn" @click="Excel()">
          <b-icon icon="cloud-download"></b-icon> Excel
        </button>
      </div>
      <CloudSyncButton v-if="inSync==true" style="width: 100%;" :title="syncProgress+'%'" :titleDone="syncProgress+'%'"
        :syncProgress="syncProgress" :inSync="inSync"
        :styling="{loadColor: '#81d427',strokeColor: '#fff',btnColor: '#aaa'}" />
      <span v-if="results[0] != null" id="oldtable">
        <md-card>
          <md-card-content>
            <table class="table table-bordered" style="font-size: 12px;">
              <thead class="thead-light">
                <tr>
                  <th class="column1" rowspan="2">#</th>
                  <th class="column1" rowspan="2">ID</th>
                  <th class="column3" rowspan="2">{{ $t("Номи") }}</th>
                  <th :class="'column'+filtertype.length" :colspan="filtertype.length">{{ $t("Бошланғич") }}</th>
                  <th :class="'column'+filtertype.length" :colspan="filtertype.length">{{ $t("Кирим") }}</th>
                  <th :class="'column'+filtertype.length" :colspan="filtertype.length">{{ $t("Расход") }}</th>
                  <th :class="'column'+filtertype.length" :colspan="filtertype.length">{{ $t("Якуний") }}</th>
                </tr>
                <tr>
                  <th class="column1" v-if="Filtercolumn('count')==1">{{$t('Сони')}}</th>
                  <th class="column1" v-if="Filtercolumn('price')==1">{{$t('Нарх')}}</th>
                  <th class="column1" v-if="Filtercolumn('summa')==1">Сумма</th>
                  <th class="column1" v-if="Filtercolumn('count')==1">{{$t('Сони')}}</th>
                  <th class="column1" v-if="Filtercolumn('price')==1">{{$t('Нарх')}}</th>
                  <th class="column1" v-if="Filtercolumn('summa')==1">Сумма</th>
                  <th class="column1" v-if="Filtercolumn('count')==1">{{$t('Сони')}}</th>
                  <th class="column1" v-if="Filtercolumn('price')==1">{{$t('Нарх')}}</th>
                  <th class="column1" v-if="Filtercolumn('summa')==1">Сумма</th>
                  <th class="column1" v-if="Filtercolumn('count')==1">{{$t('Сони')}}</th>
                  <th class="column1" v-if="Filtercolumn('price')==1">{{$t('Нарх')}}</th>
                  <th class="column1" v-if="Filtercolumn('summa')==1">Сумма</th>
                </tr>
              </thead>
              <tbody style="overflow: hidden;">
                <VueAutoVirtualScrollList :totalHeight="450" :defaultHeight="50"
                  style="width: 100%!important;height: 58vh;">
                  <tr :style="{ height: `${index / 1000 + 20}px` }" class="row100 body" style="cursor:pointer"
                    v-for="(item, index) in results" :key="index">
                    <router-link style="display: contents;" target="_blank"
                      :to="{path: '/xisobot/sverka/product/'+item.id+'/'+datas.sklad_id+'/'+datas.date1+'/'+datas.date2}">
                      <td class="column1">{{ index + 1 }}</td>
                      <td class="column1">{{ item.id }}</td>
                      <td class="column3">{{ item.name }}</td>
                      <td class="column1 kol" v-if="Filtercolumn('count')==1">
                        <span v-if="item.begin_balance>0">
                        <span v-if="pack==true && item.begin_balance>0">{{
                          (item.begin_balance/item.pack_count)|numFormats }}</span>
                        <span v-else>
                          {{ item.begin_balance|numFormats }}</span>
                          </span>
                          <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('price')==1">
                        <span v-if="item.begin_balance>0">
                        {{ Format_bosh_summa_narx(item) }}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('summa')==1">
                        <span v-if="item.begin_balance>0">
                        {{ Format_bosh_summa(item) }}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="column1 kol" v-if="Filtercolumn('count')==1">
                        <span v-if="item.balance_kirim>0">
                        <span v-if="pack==true && item.balance_kirim>0">{{
                          (item.balance_kirim/item.pack_count)|numFormats }}</span>
                        <span v-else>{{ item.balance_kirim|numFormats }}</span>
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('price')==1" >
                        <span v-if="item.balance_kirim>0">
                        {{Format_kirim_summa_narx(item)}}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('summa')==1">
                        <span v-if="item.balance_kirim>0">
                        {{ Format_kirim_summa(item) }}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="column1 kol" v-if="Filtercolumn('count')==1">
                        <span v-if="item.balance_chiqim>0">
                        <span v-if="pack==true && item.balance_chiqim>0">{{
                          (item.balance_chiqim/item.pack_count)|numFormats }}</span>
                        <span v-else>{{ item.balance_chiqim|numFormats }}</span>
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="column1 kol" v-if="Filtercolumn('price')==1">
                        <span v-if="item.balance_chiqim>0">
                        {{Format_chiqim_summa_narx(item)}}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('summa')==1">
                        <span v-if="item.balance_chiqim>0">
                        {{ Format_chiqim_summa(item) }}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="column1 kol" v-if="Filtercolumn('count')==1">
                        <span v-if="item.end_balance>0">
                        <span v-if="pack==true && item.end_balance>0">{{ (item.end_balance/item.pack_count)|numFormats
                          }}</span>
                        <span v-else>{{ item.end_balance|numFormats }}</span>
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="column1 kol" v-if="Filtercolumn('price')==1">
                        <span v-if="item.end_balance>0">
                        {{Format_end_summa_narx(item)}}
                      </span>
                      <span v-else>0</span>
                      </td>
                      <td class="kol column1" v-if="Filtercolumn('summa')==1">
                        <span v-if="item.end_balance>0">
                        {{ Format_end_summa(item) }}
                      </span>
                      <span v-else>0</span>
                      </td>
                    </router-link>
                  </tr>
                </VueAutoVirtualScrollList>
              </tbody>
              <thead class="thead-light spesific">
                <tr>
                  <th class="column5">{{$t('Жами')}}</th>
                  <th class="column1 kol" v-if="Filtercolumn('count')==1">{{ summ.begin_kol | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('price')==1"></th>
                  <th class="column1 kol" v-if="Filtercolumn('summa')==1">{{ summ.begin_summ | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('count')==1">{{ summ.kirim_kol | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('price')==1"></th>
                  <th class="column1 kol" v-if="Filtercolumn('summa')==1">{{ summ.kirim_summ | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('count')==1">{{ summ.chiqim_kol | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('price')==1"></th>
                  <th class="column1 kol" v-if="Filtercolumn('summa')==1">{{ summ.chiqim_summ | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('count')==1">{{ summ.end_kol | numFormats }}</th>
                  <th class="column1 kol" v-if="Filtercolumn('price')==1"></th>
                  <th class="column1 kol" v-if="Filtercolumn('summa')==1">{{ summ.end_summ | numFormats }}</th>
                </tr>
              </thead>
            </table>
          </md-card-content>
        </md-card>
      </span>
    </b-row>
    <sklad :datas="datas"></sklad>
  </b-container>
</template>

<script>
  var XLSX = require("xlsx");
  import ZkTable from 'vue-table-with-tree-grid';
  var FileSaver = require("file-saver");
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
  import { print } from "../../../components/mixins/print.js";
  import { Sklad } from "@/pages";
  import CloudSyncButton from "@vuesence/cloud-sync-button";
  export default {
    components: { Sklad, ZkTable, VueAutoVirtualScrollList, CloudSyncButton },
    mixins: [print],
    data() {
      return {
        folderlist: [],
        datas: {
          date1: new Date().toISOString().slice(0, 8) + "01",
          date2: new Date().toISOString().slice(0, 10),
          product_id: null,
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          price: "chakana_price"
        },
        settinglist: [{ id: "count", name: this.$t("Сони") }, { id: "price", name: this.$t("Нарх") }, { id: "summa", name: this.$t("Сумма") }],
        pack: false,
        movement: false,
        filtertype: ['count', 'price', 'summa'],
        valuta: 'sum',
        senalist: [
          { id: "prixod_price", name: this.$t("Кирим") },
          { id: "optom_price", name: this.$t("Улгуржи") },
          { id: "chakana_price", name: this.$t("Чакана") }
        ],
        pricelist: [
          { id: 'dollar', name: 'Доллар' },
          { id: 'sum', name: 'Cўм' }
        ],
        summ: {
          begin_kol: 0,
          begin_summ: 0,
          kirim_kol: 0,
          kirim_summ: 0,
          chiqim_kol: 0,
          chiqim_summ: 0,
          end_kol: 0,
          end_summ: 0
        },
        sklad: "",
        skladlist: [],
        results: []
      };
    },
    computed: {
      propList() {
        return Object.keys(this.props).map(item => ({
          name: item,
        }));
      },
    },
    mounted() {
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          this.datas.product_id = parseInt(
            localStorage.getItem("setted_product")
          );
          localStorage.setItem("setted_product", 0);
        }
      }),
        setTimeout(() => {
          localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
          localStorage.setItem("created_at_dok", this.datas.date2);
        }, 1000);
      if (this.datas.sklad_id != 1) {
        this.senalist = [{ id: "optom_price", name: this.$t("Улгуржи") },
        { id: "chakana_price", name: this.$t("Чакана") }];
      }
    },
    created() {
      let self = this;
      self.Folderlist();
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function (response) {
          self.dollar_rate = response.data.rate;
        });
    },
    methods: {
      Filtercolumn(type) {
        let oddNumbers = this.filtertype.filter(number => number == type);
        return oddNumbers.length;
      },
      Folderlist() {
        let self = this;
        axios.get("api/v1/product/folder-list").then(function (response) {
          self.folderlist = response.data;
        });
      },
      Format: function (field, data, column) {
        return this.$options.filters.numFormat0(data[field]);
      },
      Format_bosh_summa: function (item) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.begin_debit_summa);
            } else {
              return this.$options.filters.numFormats(item.begin_debit_summa * this.dollar_rate);
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.begin_debit_summa / this.dollar_rate);
            } else {
              return this.$options.filters.numFormats(item.begin_debit_summa);
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.$options.filters.numFormats(item.begin_optom_summa);
        } else if (this.datas.price == "chakana_price") {
          return this.$options.filters.numFormats(item.begin_chakana_summa);
        }
      },
      Format_bosh_summa_narx: function (item) {
        var result = 1;
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              result = item.begin_debit_summa;
            } else {
              result = item.begin_debit_summa * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              result = item.begin_debit_summa / this.dollar_rate;
            } else {
              result = item.begin_debit_summa;
            }
          }
        } else if (this.datas.price == "optom_price") {
          result = item.begin_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          result = item.begin_chakana_summa;
        }
        if (result > 0 && item.begin_balance>0) {
          if (this.pack == true) {
            return this.$options.filters.numFormats(result / item.begin_balance * item.pack_count);
          } else {
            if (item.begin_balance > 0) {
              return this.$options.filters.numFormats(result / item.begin_balance);
            } else {
              return result;
            }
          }
        } else {
          return 0;
        }
      },
      Format_kirim_summa: function (item) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.debit_summa_kirim);
            } else {
              return this.$options.filters.numFormats(item.debit_summa_kirim * this.dollar_rate);
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.debit_summa_kirim / this.dollar_rate);
            } else {
              return this.$options.filters.numFormats(item.debit_summa_kirim);
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.$options.filters.numFormats(item.optom_summa_kirim);
        } else if (this.datas.price == "chakana_price") {
          return this.$options.filters.numFormats(item.chakana_summa_kirim);
        }
      },
      Format_kirim_summa_narx: function (item) {
        var result = 1;
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              result = item.debit_summa_kirim;
            } else {
              result = item.debit_summa_kirim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              result = item.debit_summa_kirim / this.dollar_rate;
            } else {
              result = item.debit_summa_kirim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          result = item.optom_summa_kirim;
        } else if (this.datas.price == "chakana_price") {
          result = item.chakana_summa_kirim;
        }
        if (result > 0) {
          if (this.pack == true) {
            return this.$options.filters.numFormats(result / item.balance_kirim * item.pack_count);
          } else {
            return this.$options.filters.numFormats(result / item.balance_kirim);
          }
        } else {
          return 0;
        }
      },
      Format_chiqim_summa: function (item) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.debit_summa_chiqim);
            } else {
              return this.$options.filters.numFormats(item.debit_summa_chiqim * this.dollar_rate);
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.debit_summa_chiqim / this.dollar_rate);
            } else {
              return this.$options.filters.numFormats(item.debit_summa_chiqim);
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.$options.filters.numFormats(item.optom_summa_chiqim);
        } else if (this.datas.price == "chakana_price") {
          return this.$options.filters.numFormats(item.chakana_summa_chiqim);
        }
      },
      Format_chiqim_summa_narx: function (item) {
        var result = 0;
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              result = item.debit_summa_chiqim;
            } else {
              result = item.debit_summa_chiqim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              result = item.debit_summa_chiqim / this.dollar_rate;
            } else {
              result = item.debit_summa_chiqim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          result = item.optom_summa_chiqim;
        } else if (this.datas.price == "chakana_price") {
          result = item.chakana_summa_chiqim;
        }
        if (result > 0) {
          if (this.pack == true) {
            return this.$options.filters.numFormats(result / item.balance_chiqim * item.pack_count);
          } else {
            return this.$options.filters.numFormats(result / item.balance_chiqim);
          }
        } else {
          return 0;
        }
      },
      Format_end_summa: function (item) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.end_debit_summa);
            } else {
              return this.$options.filters.numFormats(item.end_debit_summa * this.dollar_rate);
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.$options.filters.numFormats(item.end_debit_summa / this.dollar_rate);
            } else {
              return this.$options.filters.numFormats(item.end_debit_summa);
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.$options.filters.numFormats(item.end_optom_summa);
        } else if (this.datas.price == "chakana_price") {
          return this.$options.filters.numFormats(item.end_chakana_summa);
        }
      },
      Format_end_summa_narx: function (item) {
        var result = 0;
        if (item.end_balance > 0) {
          if (this.datas.price == "prixod_price") {
            if (this.valuta == "sum") {
              if (this.sklads.common_price_type == 1) {
                result = item.end_debit_summa;
              } else {
                result = item.end_debit_summa * this.dollar_rate;
              }
            } else {
              if (this.sklads.common_price_type == 1) {
                result = item.end_debit_summa / this.dollar_rate;
              } else {
                result = item.end_debit_summa;
              }
            }
          } else if (this.datas.price == "optom_price") {
            result = item.end_optom_summa;
          } else if (this.datas.price == "chakana_price") {
            result = item.end_chakana_summa;
          }
          if (result > 0) {
            if (this.pack == true) {
              return this.$options.filters.numFormats(result / item.end_balance * item.pack_count);
            } else {
              return this.$options.filters.numFormats(result / item.end_balance);
            }
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      Table() {
        var sikl = "";
        let self = this;
        this.results.forEach(function (key, value) {
          var index = value + 1;
          sikl =
            sikl +
            `<tr>
                          <td>` +
            index +
            `</td>
                          <td>
                            ` +
            key.name +
            `
                          </td>
                          <td>
                              ` +
            self.$options.filters.numFormats(self.Begincountexcel(value)) +
            `
                          </td>
                          <td>
                            `+ self.$options.filters.numFormats(self.Beginsena(value)) + `
                            </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Beginsumma(value)) +
            `
                          </td>  
                          <td>
                             ` +
            self.$options.filters.numFormats(self.Kirimcountexcel(value)) +
            `
                          </td>
                          <td>
                            `+ self.$options.filters.numFormats(self.Kirimsena(value)) + `
                            </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Kirimsumma(value)) +
            `
                          </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Chiqimcountexcel(value)) +
            `
                          </td>
                          <td>
                            `+ self.$options.filters.numFormats(self.Chiqimsena(value)) + `
                            </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Chiqimsumma(value)) +
            `
                          </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Endcountexcel(value)) +
            `
                          </td>
                          <td>
                            `+ self.$options.filters.numFormats(self.Endsena(value)) + `
                            </td>
                          <td>
                            ` +
            self.$options.filters.numFormats(self.Endsumma(value)) +
            `
                          </td>
                        </tr>`;
        });
        var table =
          `
                <table class='table table-bordered'>
                    <tr>
                      <th rowspan="2">#</th>
                      <th rowspan="2">` +
          this.$t("Номи") +
          `</th>
                      <th colspan="3">` +
          this.$t("Бошланғич") +
          `</th>
                      <th colspan="3">` +
          this.$t("Кирим") +
          `</th>
                      <th colspan="3">` +
          this.$t("Расход") +
          `</th>
                      <th colspan="3">` +
          this.$t("Якуний") +
          `</th>
                    </tr>
                    <tr>
                      <th>Кол.</th>
                      <th>`+ this.$t('Нарх') + `</th>
                      <th>Cумма</th>
                      <th>Кол.</th>
                      <th>`+ this.$t('Нарх') + `</th>
                      <th>Cумма</th>
                      <th>Кол.</th>
                      <th>`+ this.$t('Нарх') + `</th>
                      <th>Cумма</th>
                      <th>Кол.</th>
                      <th>`+ this.$t('Нарх') + `</th>
                      <th>Cумма</th>
                    </tr>
                    <tr>
                      `+ sikl + `
                    <th colspan="2">` +
          this.$t("Жами") +
          `</th>
                    <th>` +
          this.summ.begin_kol +
          `</span></th>
        <th></th>  
                    <th>` +
          this.$options.filters.numFormats(this.summ.begin_summ) +
          `</span></th>
                    <th>` +
          this.summ.kirim_kol +
          `</span></th>
        <th></th>
                    <th>` +
          this.$options.filters.numFormats(this.summ.kirim_summ) +
          `</span></th>
                    <th>` +
          this.summ.chiqim_kol +
          `</span></th>
        <th></th>
                    <th>` +
          this.$options.filters.numFormats(this.summ.chiqim_summ) +
          `</span></th>
                    <th>` +
          this.summ.end_kol +
          `</span></th>
        <th></th>
                    <th>` +
          this.$options.filters.numFormats(this.summ.end_summ) +
          `</span></th>
                    </tr>
                </table>
          `;
        return table;
      },
      async Print2() {
        $('.headexcel>span').css('display', 'flex');
        var head = $(".headexcel").html();
        if (head == undefined) {
          head = "";
        }
        var s = $(".content input")
          .eq(0)
          .val();
        var s1 = $(".content input")
          .eq(1)
          .val();
        var table = await this.Table();
        const style = document.createElement('style');
        style.innerHTML = `
        .table-bordered th, .table-bordered td{
   border:1px solid black!important;
   }
  @media print {
    table, th, td {
      border: 1px solid black!important; /* Chegaralarni yaxshiroq qilish uchun */
      border-collapse: collapse;
    }

   

    /* Boshqa chop etish uslublari */
    body {
      font-size: 12px;
      margin: 0;
      padding: 0;
    }

    /* Chop etishda ko'rinmasligi kerak bo'lgan elementlar */
    .no-print {
      display: none;
    }
  }
`;
        document.head.appendChild(style);
        window.document.body.innerHTML = head + table;
        $("input")
          .eq(0)
          .val(s);
        $("input")
          .eq(1)
          .val(s1);
        window.print();
        window.location.reload();
      },
      Begincountexcel(index) {
        let self = this;
        var item = this.results[index];
        if (this.pack == true && item.begin_balance > 0) {
          return item.begin_balance / item.pack_count;
        } else {
          return item.begin_balance;
        }
      },
      Kirimcountexcel(index) {
        let self = this;
        var item = this.results[index];
        if (this.pack == true && item.balance_kirim > 0) {
          return item.balance_kirim / item.pack_count;
        } else {
          return item.balance_kirim;
        }
      },
      Chiqimcountexcel(index) {
        let self = this;
        var item = this.results[index];
        if (this.pack == true && item.balance_chiqim > 0) {
          return item.balance_chiqim / item.pack_count;
        } else {
          return item.balance_chiqim;
        }
      },
      Endcountexcel(index) {
        let self = this;
        var item = this.results[index];
        if (this.pack == true && item.end_balance > 0) {
          return item.end_balance / item.pack_count;
        } else {
          return item.end_balance;
        }
      },
      Excel() {
  this.$store.state.xls = true;
  $("#oldtable").html(this.Table());
  
  // Jadvalni Workbook ga aylantirish
  let wb = XLSX.utils.table_to_book(document.getElementById("oldtable")),
    ws = wb.Sheets[wb.SheetNames[0]], // Birinchi sheetni olish
    wopts = {
      bookType: "xlsx",
      bookSST: false,
      type: "binary"
    };

  // Ustun kengliklari
  var wscols = [
    { width: 5 },
    { width: 30 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 },
    { width: 13 }
  ];

  // Ustunlarni string qilish (2 va 4-ustunlar)
  const columnsToMakeString = [2]; // Ustun raqamlari (1 dan boshlanadi)
  Object.keys(ws).forEach((cellKey) => {
  if (!cellKey.startsWith('!')) {
    delete ws[cellKey].z; // Formatni o'chirish
  }
});

  // Ustun kengliklarini qo'shish
  ws['!cols'] = wscols;

  // Excel faylini yozib olish
  let wbout = XLSX.write(wb, wopts);
  FileSaver.saveAs(
    new Blob([this.s2ab(wbout)], {
      type: "application/octet-stream;charset=utf-8"
    }),
    new Date().toISOString().slice(0, 16) + "_tovarxisobot.xlsx"
  );

  setTimeout(() => {
    this.$store.state.xls = false;
    window.location.reload();
  }, 2000);
},
      Beginsena(index) {
        var item = this.results[index];
        if (this.Beginsumma(index) > 0 || item.begin_balance > 0) {
          return this.Beginsumma(index) / this.Begincountexcel(index);
        } else {
          return 0;
        }
      },
      Kirimsena(index) {
        var item = this.results[index];
        if (this.Kirimsumma(index) > 0 || item.balance_kirim > 0) {
          return this.Kirimsumma(index) / this.Kirimcountexcel(index);
        } else {
          return 0;
        }
      },
      Chiqimsena(index) {
        var item = this.results[index];
        if (this.Chiqimsumma(index) > 0 || item.balance_chiqim > 0) {
          return this.Chiqimsumma(index) / this.Chiqimcountexcel(index);
        } else {
          return 0;
        }
      },
      Endsena(index) {
        var item = this.results[index];
        if (this.Endsumma(index) > 0 || item.end_balance > 0) {
          return this.Endsumma(index) / this.Endcountexcel(index);
        } else {
          return 0;
        }
      },
      Beginsumma(index) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].begin_debit_summa;
            } else {
              return this.results[index].begin_debit_summa * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].begin_debit_summa / this.dollar_rate;
            } else {
              return this.results[index].begin_debit_summa;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].begin_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].begin_chakana_summa;
        }
      },
      Kirimsumma(index) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].debit_summa_kirim;
            } else {
              return this.results[index].debit_summa_kirim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].debit_summa_kirim / this.dollar_rate;
            } else {
              return this.results[index].debit_summa_kirim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].optom_summa_kirim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].chakana_summa_kirim;
        }
      },
      Chiqimsumma(index) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].debit_summa_chiqim;
            } else {
              return this.results[index].debit_summa_chiqim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].debit_summa_chiqim / this.dollar_rate;
            } else {
              return this.results[index].debit_summa_chiqim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].optom_summa_chiqim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].chakana_summa_chiqim;
        }
      },
      Endsumma(index) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].end_debit_summa;
            } else {
              return this.results[index].end_debit_summa * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].end_debit_summa / this.dollar_rate;
            } else {
              return this.results[index].end_debit_summa;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].end_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].end_chakana_summa;
        }
      },
      Beginsummaseria(index, index1) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].begin_debit_summa;
            } else {
              return this.results[index].series[index1].begin_debit_summa * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].begin_debit_summa / this.dollar_rate;
            } else {
              return this.results[index].series[index1].begin_debit_summa;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].begin_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].begin_chakana_summa;
        }
      },
      Kirimsummaseria(index, index1) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].debit_summa_kirim;
            } else {
              return this.results[index].series[index1].debit_summa_kirim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].debit_summa_kirim / this.dollar_rate;
            } else {
              return this.results[index].series[index1].debit_summa_kirim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].optom_summa_kirim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].chakana_summa_kirim;
        }
      },
      Chiqimsummaseria(index, index1) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].debit_summa_chiqim;
            } else {
              return this.results[index].series[index1].debit_summa_chiqim * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].debit_summa_chiqim / this.dollar_rate;
            } else {
              return this.results[index].series[index1].debit_summa_chiqim;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].optom_summa_chiqim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].chakana_summa_chiqim;
        }
      },
      Endsummaseria(index, index1) {
        if (this.datas.price == "prixod_price") {
          if (this.valuta == "sum") {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].end_debit_summa;
            } else {
              return this.results[index].series[index1].end_debit_summa * this.dollar_rate;
            }
          } else {
            if (this.sklads.common_price_type == 1) {
              return this.results[index].series[index1].end_debit_summa / this.dollar_rate;
            } else {
              return this.results[index].series[index1].end_debit_summa;
            }
          }
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].end_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].end_chakana_summa;
        }
      },
      Beginsummaitems(index, index1, index2) {
        if (this.datas.price == "prixod_price") {
          return this.results[index].series[index1].items[index2]
            .begin_debit_summa;
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].items[index2]
            .begin_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].items[index2]
            .begin_chakana_summa;
        }
      },
      Kirimsummaitems(index, index1, index2) {
        if (this.datas.price == "prixod_price") {
          return this.results[index].series[index1].items[index2]
            .debit_summa_kirim;
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].items[index2]
            .optom_summa_kirim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].items[index2]
            .chakana_summa_kirim;
        }
      },
      Chiqimsummaitems(index, index1, index2) {
        if (this.datas.price == "prixod_price") {
          return this.results[index].series[index1].items[index2]
            .debit_summa_chiqim;
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].items[index2]
            .optom_summa_chiqim;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].items[index2]
            .chakana_summa_chiqim;
        }
      },
      Endsummaitems(index, index1, index2) {
        if (this.datas.price == "prixod_price") {
          return this.results[index].series[index1].items[index2].end_debit_summa;
        } else if (this.datas.price == "optom_price") {
          return this.results[index].series[index1].items[index2].end_optom_summa;
        } else if (this.datas.price == "chakana_price") {
          return this.results[index].series[index1].items[index2]
            .end_chakana_summa;
        }
      },
      Jami() {
        let self = this;
        self.summ = {
          begin_kol: 0,
          begin_summ: 0,
          kirim_kol: 0,
          kirim_summ: 0,
          chiqim_kol: 0,
          chiqim_summ: 0,
          end_kol: 0,
          end_summ: 0
        };
        self.results.forEach(function (key, value) {
          if (self.pack == true) {
            self.summ.begin_kol += key.begin_balance / key.pack_count;
            self.summ.kirim_kol += key.balance_kirim / key.pack_count;
            self.summ.chiqim_kol += key.balance_chiqim / key.pack_count;
            self.summ.end_kol += key.end_balance / key.pack_count;

          } else {
            self.summ.begin_kol += key.begin_balance;
            self.summ.kirim_kol += key.balance_kirim;
            self.summ.chiqim_kol += key.balance_chiqim;
            self.summ.end_kol += key.end_balance;
          }
          self.summ.begin_summ += self.Beginsumma(value);
          self.summ.kirim_summ += self.Kirimsumma(value);
          self.summ.chiqim_summ += self.Chiqimsumma(value);
          self.summ.end_summ += self.Endsumma(value);
        });
      },
      Clicked(id) {
        localStorage.setItem("date1", this.datas.date1);
        localStorage.setItem("date2", this.datas.date2);
        localStorage.setItem("product_id", id);
        localStorage.setItem("sklad_id", this.datas.sklad_id);
        let routeData = this.$router.resolve({ path: "/xisobot/sverka/product" });
        window.open(routeData.href, "_blank");
      },
      Send() {
        let self = this;
        self.startSync();
        self.results = [];
        var datas = {
          datetime1: parseInt(new Date(self.datas.date1).valueOf().toString().slice(0, 10)),
          datetime2: parseInt(new Date(self.datas.date2).valueOf().toString().slice(0, 10)) + 86399,
          sklad_id: self.datas.sklad_id,
          movement: self.movement,
          product_id: self.datas.product_id
        };
        var url;
        if (self.valuta == 'dollar') {
          url = 'api/v1/report/product-dollar';
        } else {
          url = 'api/v1/report/product';
        }
        axios({
          method: "post",
          url: url,
          data: datas,
          onUploadProgress: function (progressEvent) {
            this.syncProgress = 40;
          }.bind(this)
        }
        ).then(function (response) {
          self.results = response.data;
          self.Jami();
          self.syncProgress = 100;
        });
      }
    }
  };
</script>
<style>
  .spesific .kol {
    text-align: right !important;
  }

  .spesific .left {
    text-align: left !important;
  }

  .spesific {
    width: calc(100% - 9px) !important;
  }
</style>
<style scoped>
  .my-1 {
    padding-right: 10px !important;
  }

  .second>tr {
    background: #c0c0c03d;
  }

  .first>tr {
    font-weight: bold;
    background: rgb(211, 209, 208);
  }

  .spesific td {
    font-weight: bold;
    font-size: 14px;
  }

  .spesific {
    background-color: antiquewhite;
  }
</style>